import React from 'react';
import NewsEvents from '../components/NewsEvents';

const NewsEventsPage = () => {
  return (
    <main className="pt-20">
      <NewsEvents />
    </main>
  );
};

export default NewsEventsPage; 